import { CaseStudyDetailsStack as DetailsStack } from '@rumblefish/ui/Rumblefish23Theme';
import {
  DetailsStackWrapper,
  StyledCaseStudySection,
} from './DetailsStack.styles';
import type { CaseStudyDetailsStackProps } from './DetailsStack.types';

export const CaseStudyDetailsStack = ({
  show,
  collaborationTimeframe,
  technologies,
  teamSize,
  services,
}: CaseStudyDetailsStackProps) => {
  if (!show) return null;
  return (
    <StyledCaseStudySection>
      <DetailsStackWrapper>
        <DetailsStack
          collaborationTimeframe={collaborationTimeframe}
          technologies={technologies}
          teamSize={teamSize}
          services={services}
        />
      </DetailsStackWrapper>
    </StyledCaseStudySection>
  );
};
